import { atom, useSetRecoilState, useRecoilValue } from 'recoil';
import { TokensDto } from '@oh-auth/dto';
import { useCallback, useEffect, useState } from 'react';
import { apiClientState } from './api';
import { useHistory } from 'react-router-dom';
import * as H from 'history';
export const tokensState = atom<TokensDto | null>({
	key: 'tokens',
	default: null,
});

export const referrerState = atom<H.Location<any> | null>({
	key: 'referrer',
	default: null,
});

export const persistState = atom<boolean>({
	key: 'persist',
	default: false,
});

export function useRedirectBack() {
	// const location = useLocation<{ referrer: Location }>();
	const referrer = useRecoilValue(referrerState);
	const history = useHistory();
	const tokens = useRecoilValue(tokensState);

	useEffect(() => {
		if (tokens && referrer) history.replace(referrer);
	}, [tokens, history, referrer]);
}

export function useSignIn() {
	const setTokens = useSetRecoilState(tokensState);
	const apiClient = useRecoilValue(apiClientState);

	const [error, setError] = useState(false);

	const handleSignIn = useCallback(
		(username: string, password: string, persist: boolean) => {
			async function signIn() {
				const tokens = await apiClient.signInUser(null, {
					username,
					password,
					...(username === 'admin' ? { scope: 'users apps' } : {}),
				});
				setTokens(tokens);
				if (persist) {
					localStorage.setItem('tokens', JSON.stringify(tokens));
				} else {
					sessionStorage.setItem('tokens', JSON.stringify(tokens));
				}
			}
			signIn().catch(() => setError(true));
		},
		[setTokens, apiClient, setError]
	);

	return {
		handleSignIn,
		error,
	};
}

export function useSignUp() {
	const setTokens = useSetRecoilState(tokensState);
	const apiClient = useRecoilValue(apiClientState);

	const [error, setError] = useState(false);

	const handleSignUp = useCallback(
		(
			username: string,
			password: string,
			email: string,
			persist: boolean
		) => {
			async function signIn() {
				const tokens = await apiClient.signUpUser(null, {
					username,
					password,
				});
				setTokens(tokens);
				if (persist) {
					localStorage.setItem('tokens', JSON.stringify(tokens));
				} else {
					sessionStorage.setItem('tokens', JSON.stringify(tokens));
				}
				return tokens;
			}

			async function updateUserEmail(tokens: TokensDto, email: string) {
				if (!apiClient) return;
				await apiClient.updateUserEmail(tokens, {
					user_id: tokens.sub,
					email,
				});
			}

			signIn()
				.then((tokens) => {
					return updateUserEmail(tokens, email);
				})
				.catch(() => setError(true));
		},
		[setTokens, apiClient]
	);

	return {
		handleSignUp,
		error,
	};
}

export const approvalChallengeState = atom<string | null>({
	key: 'approvalChallenge',
	default: null,
});

export const approvalVerifierState = atom<string | null>({
	key: 'approvalVerifier',
	default: null,
});

export const approvalVerifierExpiredAtState = atom<string | null>({
	key: 'approvalVerifierExpiredAt',
	default: null,
});

export const consentSessionIdState = atom<string | null>({
	key: 'consentSessionId',
	default: null,
});
